import React from 'react';
import {connect} from "react-redux";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "material-ui";
import {closeDeleteUserFetch, deleteUser} from "../../../redux/actions/users";
import {snackMessageShow} from "../../../redux/actions/snack_message";

export class UserDeleteDialog extends React.Component {

    onClickSubmit = () => {
        this.props.deleteUser(this.props.user, () => {
            this.props.handleClose();
        });
    };

    render() {

        const {open, handleClose} = this.props;

        return (
            <Dialog
                open={open}>

                <DialogTitle>
                    ユーザーの削除
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        選択したユーザーを削除します。<br/>
                        この操作で削除されたデータは、復旧することができません。<br/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="default">
                        キャンセル
                    </Button>
                    <Button onClick={this.onClickSubmit.bind(this)} color="primary" autoFocus>
                        削除する
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

UserDeleteDialog = connect(
    (state) => {
        return {
            user: state.users.user,
        }
    },
    (dispatch) => {
        return {
            deleteUser: (user, callback) => {
                dispatch(deleteUser(user)).then((response) => {
                    setTimeout(() => {
                        dispatch(closeDeleteUserFetch());
                        switch (response.type) {
                            case 'API_DELETE_USER_FAIL':
                                dispatch(snackMessageShow('ユーザーの削除に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('ユーザーを削除しました'));
                                callback();
                        }
                    }, 200);
                });
            },
        }
    }
)(UserDeleteDialog);


// WEBPACK FOOTER //
// ./src/containers/user/dialog/delete.js